import { getIsActiveCustomerContext } from "Auth/Api/Queries/Context/contextUtils";
import { useGetContextsQuery } from "Auth/Api/Queries/Context/useGetContextsQuery";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { useSwitchContextWithReload } from "Hooks/useSwitchContextWithReload";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.LicensePaymentPending;

// Escape hatch for license-blocked hunters: switch back to their Customer
// context (full app reload). Renders nothing when the user has no active
// Customer context (hunter-only or legacy non-Identity accounts).
export const BackToMooneButton = () => {
  const { t } = useResource();
  const user = useLoggedInUser();
  const { data } = useGetContextsQuery(!!user);
  const { switchContext, isSwitching } = useSwitchContextWithReload();

  const customerContext = data?.contexts?.find(getIsActiveCustomerContext);

  if (!customerContext) {
    return null;
  }

  const { identityUserPublicID } = customerContext;

  return (
    <PrimaryButton
      variant="contained"
      color="primary"
      fullWidth
      isLoading={isSwitching}
      onClick={() => switchContext({ identityUserPublicID })}
    >
      {t(RESOURCES.BackToMoone)}
    </PrimaryButton>
  );
};
